"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagementMode = void 0;
var ManagementMode;
(function (ManagementMode) {
    ManagementMode["CASH"] = "CASH";
    ManagementMode["PRE"] = "PRE";
    ManagementMode["POST"] = "POST";
})(ManagementMode = exports.ManagementMode || (exports.ManagementMode = {}));
